import React from 'react';
import { ProgressBar, Alert } from 'react-bootstrap';
import { useTheme } from '../themeControl/ThemeProvider';
import './ProgressTracker.css';

/**
 * Reusable Progress Tracker Component
 * Shows progress bar, status messages, and completion status
 */
export const ProgressTracker = ({ 
    title = "Processing", 
    progress = { current: 0, total: 0, percentage: 0 },
    status = { message: "", type: "info" },
    isProcessing = false,
    showProgress = true 
}) => {
    const { current, total, percentage } = progress;
    const { message, type } = status;
    const { theme } = useTheme();

    // Don't render if not processing and no status message
    if (!isProcessing && !message) {
        return null;
    }

    return (
        <div id={theme} className="progress-tracker-container">
            <div className="progress-tracker-content">
                {/* Title */}
                {title && (
                    <h6 className="progress-tracker-title">
                        {isProcessing ? `🔄 ${title}...` : `✅ ${title} Complete`}
                    </h6>
                )}

                {/* Status Message */}
                {message && (
                    <Alert 
                        variant={type} 
                        className="progress-tracker-alert"
                    >
                        {message}
                    </Alert>
                )}

                {/* Progress Bar */}
                {showProgress && total > 0 && (
                <div className="progress-tracker-progress">
                    <div className="progress-tracker-stats">
                        <span>{current} / {total} items</span>
                        <span>{percentage}%</span>
                    </div>
                    <ProgressBar 
                        now={percentage} 
                        variant={
                            percentage === 100 ? 'success' : 
                            percentage > 50 ? 'info' : 'primary'
                        }
                        className="progress-tracker-bar"
                    />
                </div>
            )}

            {/* Processing indicator for indeterminate progress */}
            {showProgress && isProcessing && total === 0 && (
                <div className="progress-tracker-processing">
                    <ProgressBar 
                        animated 
                        now={100} 
                        variant="info"
                        className="progress-tracker-bar-animated"
                    />
                    <div className="progress-tracker-processing-text">
                        Processing...
                    </div>
                </div>
            )}
            </div>
        </div>
    );
};

export default ProgressTracker;